// extracted by mini-css-extract-plugin
module.exports = {"certify":"Certify_certify__d4uOz"};